import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const HoppProConcept = () => {
  const [selectedTech, setSelectedTech] = useState('vario');

  const houses = [
    {
      name: 'Venezia',
      slug: 'venezia',
      bruttoArea: '212 m²',
      nettoArea: '176,6 m²',
      image: '/dvb-venezia.jpg',
      description: 'Tágas családi ház modern kialakítással',
      type: 'vario'
    },
    {
      name: 'Genova',
      slug: 'genova',
      bruttoArea: '110 m²',
      nettoArea: '91,56 m²',
      image: '/dvb-genova.jpg',
      description: 'Kompakt és praktikus alaprajz',
      type: 'vario'
    },
    {
      name: 'Verona',
      slug: 'verona',
      bruttoArea: '100 m²',
      nettoArea: '85,5 m²',
      image: '/dvb-verona.jpg',
      description: 'Ideális kisebb családok számára',
      type: 'vario'
    },
    {
      name: 'Siena',
      slug: 'siena',
      bruttoArea: '64 m²',
      nettoArea: '71,3 m²',
      image: '/dvb-siena.jpg',
      description: 'Költséghatékony megoldás',
      type: 'vario'
    },
    {
      name: 'Viablokk',
      slug: 'viablokk',
      bruttoArea: 'Egyedi méret',
      nettoArea: 'Tervezés szerint',
      image: '/dvb-viablokk.jpg',
      description: 'Szilárd falazatú YTONG családi ház',
      type: 'viablokk'
    }
  ];

  const features = [
    {
      icon: '🏗️',
      title: 'Modern technológia',
      description: 'A modul házak nem előre készített épületek, hanem a helyszínen, pontalapra felépített, modern falazó modulokból épülnek fel.'
    },
    {
      icon: '📊',
      title: 'Kiszámíthatóság',
      description: 'A könnyűszerkezetű épületek kivitelezési költségei pontosan tervezhetők.'
    },
    {
      icon: '🏘️',
      title: 'Mindenhol jól mutat',
      description: 'Széleskörű alkalmazhatóság: legyen szó családi házról, nyaralóról, vagy irodáról.'
    },
    {
      icon: '💰',
      title: 'Alacsony költségek',
      description: 'Házainkat kiemelkedő műszaki tartalom és alacsony rezsiköltség jellemzi.'
    },
    {
      icon: '🌿',
      title: 'Környezettudatos otthon',
      description: 'Természetes falazatok, minimális hulladék, akár nulla külső energiafogyasztás, tökéletes hőszigetelési mutatók.'
    },
    {
      icon: '⚡',
      title: 'Kiemelkedő energetika',
      description: 'Minden házunk már standard kivitelben is teljesíti a BB energetikai követelményeket, de kis ráfordítással az AA-t is könnyen elérhetjük!'
    },
    {
      icon: '💎',
      title: 'Kiváló ár/érték arány',
      description: 'A hagyományos építési technológiákhoz képest akár olcsóbb bekerülési költségek, kompromisszumok nélkül.'
    },
    {
      icon: '⏱️',
      title: 'Gyors kivitelezés',
      description: 'Akár 10 hét alatt elkészülhet otthona.'
    },
    {
      icon: '📐',
      title: 'Nagyobb nettó terület',
      description: 'Azonos bruttó beépített terület mellett akár 15%-al nagyobb nettó terület! Akár 5-8 millió forint spórolás egy téglaházhoz képest.'
    }
  ];

  return (
    <>
      <Helmet>
        <title>Hopp ProConcept Modulházak | HoppHomes</title>
        <meta name="description" content="Hopp ProConcept minőségi modulházak. Vario-Haus és ProKoncept technológiák. Gyors kivitelezés, kiváló energetika, elérhető árak." />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-b from-[#0a0a0a] via-[#1a1a1a] to-[#0a0a0a] text-white">
        
        {/* Hero Section - REDESIGNED */}
        <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
          {/* Animated Background */}
          <div className="absolute inset-0">
            <div className="absolute inset-0 bg-gradient-to-br from-amber-900/20 via-[#1a1a1a] to-emerald-900/20"></div>
            <div className="absolute inset-0 bg-[url('/grid.svg')] opacity-10"></div>
            
            {/* Floating Shapes */}
            <div className="absolute top-20 left-10 w-72 h-72 bg-amber-600/10 rounded-full blur-3xl animate-pulse"></div>
            <div className="absolute bottom-20 right-10 w-96 h-96 bg-emerald-600/10 rounded-full blur-3xl animate-pulse" style={{animationDelay: '1s'}}></div>
            <div className="absolute top-1/2 left-1/2 w-64 h-64 bg-orange-600/10 rounded-full blur-3xl animate-pulse" style={{animationDelay: '2s'}}></div>
          </div>
          
          <div className="relative z-10 text-center px-4 sm:px-6 max-w-6xl mx-auto">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-600/20 to-orange-600/20 backdrop-blur-xl border border-amber-500/30 rounded-full px-6 py-3 mb-8 shadow-2xl shadow-amber-500/20">
              <span className="relative flex h-3 w-3">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-amber-500"></span>
              </span>
              <span className="text-amber-400 font-bold text-sm tracking-wider">🏗️ HOPPHOMES SAJÁT TERMÉK</span>
            </div>
            
            {/* Main Title */}
            <h1 className="text-5xl sm:text-6xl md:text-8xl font-black mb-6 leading-tight">
              <span className="bg-gradient-to-r from-amber-400 via-orange-500 to-amber-600 bg-clip-text text-transparent drop-shadow-2xl">
                Hopp ProConcept
              </span>
            </h1>
            
            {/* Subtitle */}
            <p className="text-xl sm:text-2xl md:text-3xl text-gray-300 mb-4 leading-relaxed font-light max-w-4xl mx-auto">
              Jövőbe mutató modulházak
            </p>
            <p className="text-base sm:text-lg text-gray-400 mb-12 max-w-3xl mx-auto">
              Modern technológiákra alapuló, alacsony fenntartási költségű és gyorsan kivitelezhető otthonok. Magas minőség, elérhető áron.
            </p>
            
            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a 
                href="tel:+36304130001"
                className="group relative overflow-hidden bg-gradient-to-r from-amber-600 to-orange-600 hover:from-amber-500 hover:to-orange-500 text-white font-bold px-8 py-4 rounded-xl transition-all duration-300 text-lg shadow-2xl shadow-amber-600/50 hover:shadow-amber-500/70 hover:scale-105 w-full sm:w-auto"
              >
                <span className="relative z-10 flex items-center justify-center gap-2">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/>
                  </svg>
                  +36 30 413 0001
                </span>
                <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>
              </a>
              
              <a 
                href="mailto:hoppxplatform@gmail.com"
                className="group bg-white/10 hover:bg-white/20 backdrop-blur-xl border-2 border-white/[0.08] hover:border-amber-500/50 text-white font-bold px-8 py-4 rounded-xl transition-all duration-300 text-lg hover:scale-105 w-full sm:w-auto"
              >
                <span className="flex items-center justify-center gap-2">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/>
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>
                  </svg>
                  Kapcsolatfelvétel
                </span>
              </a>
            </div>
            
            {/* Stats */}
            <div className="grid grid-cols-3 gap-8 mt-16 max-w-3xl mx-auto">
              <div className="text-center">
                <div className="text-3xl sm:text-4xl font-black text-amber-500 mb-2">100%</div>
                <div className="text-sm text-gray-400">Magyar gyártás</div>
              </div>
              <div className="text-center">
                <div className="text-3xl sm:text-4xl font-black text-amber-500 mb-2">30 nap</div>
                <div className="text-sm text-gray-400">Kivitelezés</div>
              </div>
              <div className="text-center">
                <div className="text-3xl sm:text-4xl font-black text-amber-500 mb-2">A++</div>
                <div className="text-sm text-gray-400">Energetika</div>
              </div>
            </div>
          </div>
        </section>

        {/* Features Section - REDESIGNED */}
        <section className="py-20 px-4 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a] via-[#1a1a1a] to-[#0a0a0a]"></div>
          
          <div className="max-w-7xl mx-auto relative z-10">
            <div className="text-center mb-16">
              <h2 className="text-4xl sm:text-5xl md:text-6xl font-black mb-4">
                <span className="bg-gradient-to-r from-amber-400 to-orange-500 bg-clip-text text-transparent">
                  Miért ProConcept?
                </span>
              </h2>
              <p className="text-xl text-gray-400 max-w-2xl mx-auto">
                Innovatív megoldások, amelyek megváltoztatják az otthonépítést
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {features.map((feature, index) => (
                <div 
                  key={index}
                  className="group relative bg-gradient-to-br from-white/5 to-white/0 backdrop-blur-xl border border-white/10 rounded-2xl p-8 hover:border-amber-500/50 transition-all duration-500 hover:scale-105 hover:shadow-2xl hover:shadow-amber-500/20"
                  style={{animationDelay: `${index * 100}ms`}}
                >
                  <div className="absolute inset-0 bg-gradient-to-br from-amber-600/0 to-orange-600/0 group-hover:from-amber-600/10 group-hover:to-orange-600/10 rounded-2xl transition-all duration-500"></div>
                  
                  <div className="relative z-10">
                    <div className="text-6xl mb-6 transform group-hover:scale-110 transition-transform duration-300">{feature.icon}</div>
                    <h3 className="text-2xl font-bold mb-4 text-white group-hover:text-amber-400 transition-colors">{feature.title}</h3>
                    <p className="text-gray-400 leading-relaxed">{feature.description}</p>
                  </div>
                  
                  <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-amber-500/20 to-transparent rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Technology Section */}
        <section className="py-16 px-4">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-6">
              Technológiák
            </h2>
            
            {/* Technology Introduction */}
            <div className="max-w-4xl mx-auto mb-12">
              <p className="text-xl text-gray-300 text-center mb-8 leading-relaxed">
                Szigorúan ellenőrzött körülmények között, teljes magasságban, saroktól sarokig gyártott külső falakból, válasz falakból és tető elemekből álló épületek.
              </p>
              
              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-[#23272f] border border-white/10 rounded-xl p-6">
                  <h3 className="text-lg font-bold mb-3 text-secondary">🏭 Gondos előkészületek</h3>
                  <p className="text-gray-300 text-sm leading-relaxed">
                    Az elemeket gyárban ideális körülmények között készítik el, és az építkezés helyszínére szállítva az előkészített alapon szerelnek össze. Már akár a gyárban beszerelésre kerülnek a külső nyílászárók és előkészítik a villanyszerelést is.
                  </p>
                </div>
                
                <div className="bg-[#23272f] border border-white/10 rounded-xl p-6">
                  <h3 className="text-lg font-bold mb-3 text-secondary">✅ Ellenőrzött minőség</h3>
                  <p className="text-gray-300 text-sm leading-relaxed">
                    Gyártóüzemben csak gondosan kezelt európai faüzemben szárított fenyő anyagot építenek a falszerkezetbe, folyamatos minőségellenőrzést végeznek, a termékről tanúsítványt bocsátanak ki.
                  </p>
                </div>
                
                <div className="bg-[#23272f] border border-white/10 rounded-xl p-6">
                  <h3 className="text-lg font-bold mb-3 text-secondary">🏗️ Időtálló minőség</h3>
                  <p className="text-gray-300 text-sm leading-relaxed">
                    A magas fokú minőségnek köszönhetően a falak akár több száz évig is megőrizték szerkezetüket. A fa olyan különleges építőanyag, ami egyedülálló képességgel rendelkezik a hő- és a hangszigetelés területén.
                  </p>
                </div>
                
                <div className="bg-[#23272f] border border-white/10 rounded-xl p-6">
                  <h3 className="text-lg font-bold mb-3 text-secondary">⏱️ Gyors kivitelezés</h3>
                  <p className="text-gray-300 text-sm leading-relaxed">
                    A pontalapra helyezett épületek kivitelezése akár 3 hónap alatt is megoldható. Az engedélyeztetés további 4-6 hetet vehet igénybe.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Technology Tabs */}
            <div className="flex justify-center gap-3 sm:gap-4 mb-8 sm:mb-12 overflow-x-auto pb-2 px-4 sm:px-0 -mx-4 sm:mx-0">
              <button
                onClick={() => setSelectedTech('vario')}
                className={`px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-bold transition-all duration-200 whitespace-nowrap touch-manipulation min-w-[140px] sm:min-w-0 ${
                  selectedTech === 'vario' 
                    ? 'bg-secondary text-white scale-105' 
                    : 'bg-white/10 text-gray-400 hover:bg-white/20 active:bg-white/30'
                }`}
              >
                Vario-Haus
              </button>
              <button
                onClick={() => setSelectedTech('prokoncept')}
                className={`px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-bold transition-all duration-200 whitespace-nowrap touch-manipulation min-w-[140px] sm:min-w-0 ${
                  selectedTech === 'prokoncept' 
                    ? 'bg-secondary text-white scale-105' 
                    : 'bg-white/10 text-gray-400 hover:bg-white/20 active:bg-white/30'
                }`}
              >
                ProKoncept
              </button>
            </div>

            {/* Vario-Haus Content */}
            {selectedTech === 'vario' && (
              <div className="bg-[#23272f] border border-white/10 rounded-xl p-8">
                <h3 className="text-2xl font-bold mb-6">Vario-Haus Technológia</h3>
                
                {/* Hero Image */}
                <div className="mb-8 rounded-xl overflow-hidden">
                  <img 
                    src="/dvb-variohaus-main.jpg" 
                    alt="Vario-Haus technológia"
                    className="w-full h-64 object-cover"
                  />
                </div>

                <div className="space-y-4 text-gray-300 mb-8">
                  <p>
                    Szigorúan ellenőrzött körülmények között, teljes magasságban, saroktól sarokig gyártott külső falakból, válasz falakból és tető elemekből álló épületek.
                  </p>
                  
                  <div className="grid md:grid-cols-2 gap-6 mt-6">
                    <div className="bg-black/30 rounded-lg p-6 border border-secondary/20">
                      <h4 className="font-bold text-lg mb-3 text-secondary">⚡ EnergyLine a Vario-Haus</h4>
                      <p className="text-sm text-gray-300 leading-relaxed">
                        A falszerkezet <strong className="text-white">41,1 cm vastagságú</strong>, amelynél egy 8 cm-es installációs előtétfal kerül beépítésre. A 3 rétegű energiatakarékos ablakok beépítésével és 10 cm vastag homlokzati hőszigetelő rendszerrel elérték, hogy az <strong className="text-secondary">U érték = 0,11 W/m²K</strong>.
                      </p>
                    </div>
                    
                    <div className="bg-black/30 rounded-lg p-6 border border-secondary/20">
                      <h4 className="font-bold text-lg mb-3 text-secondary">🏗️ MGO SIP</h4>
                      <p className="text-sm text-gray-300 leading-relaxed">
                        Könnyűszerkezetes modern lakóépület MgO lap borítással, grafitos EPS szigeteléssel és lemeztetővel.
                      </p>
                    </div>
                    
                    <div className="bg-black/30 rounded-lg p-6">
                      <h4 className="font-bold text-lg mb-3 text-white">🌳 Időtálló minőség</h4>
                      <p className="text-sm text-gray-300 leading-relaxed">
                        A magas fokú minőségnek köszönhetően a falak akár több száz évig is megőrizték szerkezetüket. A fa olyan különleges építőanyag, ami egyedülálló képességgel rendelkezik a hő- és a hangszigetelés területén.
                      </p>
                    </div>
                    
                    <div className="bg-black/30 rounded-lg p-6">
                      <h4 className="font-bold text-lg mb-3 text-white">⏱️ Gyors kivitelezés</h4>
                      <p className="text-sm text-gray-300 leading-relaxed">
                        A pontalapra helyezett épületek kivitelezése akár 3 hónap alatt is megoldható. Az engedélyeztetés további 4-6 hetet vehet igénybe.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* ProKoncept Content */}
            {selectedTech === 'prokoncept' && (
              <div className="bg-[#23272f] border border-white/10 rounded-xl p-8">
                <h3 className="text-2xl font-bold mb-6">ProKoncept Technológia</h3>
                <p className="text-gray-300 mb-8">
                  Szerkezetépítés és a tökéletes, hőhídmentes hőszigetelés egy lépésben.
                </p>
                
                <div className="grid md:grid-cols-3 gap-6">
                  <div className="bg-black/30 rounded-lg overflow-hidden group hover:border-secondary/50 border border-transparent transition-all">
                    <div className="aspect-video overflow-hidden">
                      <img 
                        src="/dvb-prokoncept-fal.jpg" 
                        alt="ProKoncept Falazóelem"
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                      />
                    </div>
                    <div className="p-6 text-center">
                      <div className="text-4xl mb-4">🧱</div>
                      <h4 className="font-bold text-lg mb-3">Falazóelem</h4>
                      <p className="text-sm text-gray-400">
                        Modern falazó modulok kiváló hőszigetelési tulajdonságokkal
                      </p>
                    </div>
                  </div>
                  
                  <div className="bg-black/30 rounded-lg overflow-hidden group hover:border-secondary/50 border border-transparent transition-all">
                    <div className="aspect-video overflow-hidden">
                      <img 
                        src="/dvb-prokoncept-fodem.jpg" 
                        alt="ProKoncept Födémelem"
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                      />
                    </div>
                    <div className="p-6 text-center">
                      <div className="text-4xl mb-4">📐</div>
                      <h4 className="font-bold text-lg mb-3">Födémelem</h4>
                      <p className="text-sm text-gray-400">
                        Strapabíró és energiatakarékos födémszerkezet
                      </p>
                    </div>
                  </div>
                  
                  <div className="bg-black/30 rounded-lg overflow-hidden group hover:border-secondary/50 border border-transparent transition-all">
                    <div className="aspect-video overflow-hidden">
                      <img 
                        src="/dvb-prokoncept-teto.jpg" 
                        alt="ProKoncept Tetőelem"
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                      />
                    </div>
                    <div className="p-6 text-center">
                      <div className="text-4xl mb-4">🏠</div>
                      <h4 className="font-bold text-lg mb-3">Tetőelem</h4>
                      <p className="text-sm text-gray-400">
                        Komplett tetőszerkezet gyors szerelhetőséggel
                      </p>
                    </div>
                  </div>
                </div>

                <div className="mt-8 bg-black/30 rounded-lg p-6">
                  <h4 className="font-bold text-lg mb-3 text-white">🏗️ MGO SIP Technológia</h4>
                  <p className="text-gray-300">
                    Könnyűszerkezetes modern lakóépület MgO lap borítással, grafitos EPS szigeteléssel és lemeztetővel. Időtálló minőség - a magas fokú minőségnek köszönhetően a falak akár több száz évig is megőrizték szerkezetüket.
                  </p>
                </div>
              </div>
            )}
          </div>
        </section>

        {/* Houses Section - REDESIGNED */}
        <section className="py-20 px-4 relative">
          <div className="absolute inset-0 bg-[#0a0a0a]"></div>
          
          <div className="max-w-7xl mx-auto relative z-10">
            <div className="text-center mb-16">
              <h2 className="text-4xl sm:text-5xl md:text-6xl font-black mb-4">
                <span className="bg-gradient-to-r from-amber-400 to-orange-500 bg-clip-text text-transparent">
                  Házaink
                </span>
              </h2>
              <p className="text-xl text-gray-400 max-w-3xl mx-auto">
                Vario-Haus típusházak és Viablokk szilárd falazatú családi házak - Válassza ki az Önnek tökéletes otthont
              </p>
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
              {houses.map((house, index) => (
                <Link
                  key={index}
                  to={house.type === 'viablokk' ? `/hopp-proconcept/viablokk` : `/hopp-proconcept/${house.slug}`}
                  className="group relative bg-gradient-to-br from-white/5 to-white/0 backdrop-blur-xl border border-white/10 rounded-3xl overflow-hidden hover:border-amber-500/50 transition-all duration-500 hover:scale-105 hover:shadow-2xl hover:shadow-amber-500/30"
                >
                  {/* Special Badge for Viablokk */}
                  {house.type === 'viablokk' && (
                    <div className="absolute top-4 right-4 z-20 bg-gradient-to-r from-amber-600 to-orange-600 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg">
                      ⭐ PREMIUM
                    </div>
                  )}
                  
                  {/* Image */}
                  <div className="relative aspect-[4/3] overflow-hidden">
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent z-10"></div>
                    <img 
                      src={house.image} 
                      alt={house.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                    
                    {/* Overlay Info */}
                    <div className="absolute bottom-0 left-0 right-0 p-6 z-20">
                      <h3 className="text-2xl font-black text-white mb-2 drop-shadow-lg">{house.name}</h3>
                    </div>
                  </div>
                  
                  {/* Content */}
                  <div className="p-6">
                    <p className="text-gray-400 mb-4 line-clamp-2">{house.description}</p>
                    
                    <div className="flex items-center justify-between mb-4">
                      <div className="flex items-center gap-2 text-sm">
                        <svg className="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"/>
                        </svg>
                        <span className="text-gray-300">{house.bruttoArea}</span>
                      </div>
                      <div className="text-xs text-gray-500">Nettó: {house.nettoArea}</div>
                    </div>
                    
                    <div className="flex items-center justify-between text-amber-500 font-bold group-hover:text-amber-400 transition-colors">
                      <span>Részletek</span>
                      <svg className="w-5 h-5 transform group-hover:translate-x-2 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                      </svg>
                    </div>
                  </div>
                  
                  {/* Hover Glow */}
                  <div className="absolute inset-0 bg-gradient-to-t from-amber-600/0 to-orange-600/0 group-hover:from-amber-600/10 group-hover:to-orange-600/10 transition-all duration-500 pointer-events-none"></div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="py-16 px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Kérjen ajánlatot még ma!
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Szakértő csapatunk segít megtalálni az Önnek legmegfelelőbb Hopp ProConcept modulházat.
            </p>
            
            <div className="bg-[#23272f] border border-white/10 rounded-xl p-8">
              <div className="bg-gradient-to-r from-secondary/20 to-transparent border border-secondary/30 rounded-lg p-6 mb-8">
                <h3 className="text-2xl font-bold mb-3 text-white">🏗️ HoppHomes Saját Termék</h3>
                <p className="text-gray-300 leading-relaxed">
                  A <strong className="text-secondary">Hopp ProConcept</strong> a HoppHomes saját fejlesztésű modulház rendszere. 
                  Teljes körű tanácsadást, árajánlatot és kivitelezési támogatást biztosítunk!
                </p>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div className="text-left">
                  <h3 className="font-bold text-lg mb-2 text-secondary">📞 Telefon</h3>
                  <a href="tel:+36304130001" className="text-2xl hover:text-secondary transition-colors">
                    +36 30 413 0001
                  </a>
                  <p className="text-sm text-gray-500 mt-1">HoppHomes ügyfélszolgálat</p>
                </div>
                <div className="text-left">
                  <h3 className="font-bold text-lg mb-2 text-secondary">✉️ Email</h3>
                  <a href="mailto:hoppxplatform@gmail.com" className="text-xl hover:text-secondary transition-colors break-all">
                    hoppxplatform@gmail.com
                  </a>
                  <p className="text-sm text-gray-500 mt-1">Hopp ProConcept ajánlatkérés</p>
                </div>
              </div>
            </div>
          </div>
        </section>

      </div>
    </>
  );
};

export default HoppProConcept;
